var map = {
	"./Dropdown.vue": "5a16",
	"./Events.vue": "0d7b",
	"./EventsFilter.vue": "6be2",
	"./Figures.vue": "c220",
	"./Foo.vue": "7c46",
	"./InlineSvg.vue": "7ea1",
	"./LocationMap.vue": "1b68",
	"./Modal.vue": "e16e",
	"./PersonCard.vue": "01cf",
	"./ServicesItem.vue": "7d97",
	"./Slider.vue": "1911",
	"./Tab.vue": "c564",
	"./Tabs.vue": "2f22",
	"./TopSlider.vue": "fc59"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0c1c";